import DapDSCardContent from './card-content.component'

export * from './card-content.component'
export default DapDSCardContent

DapDSCardContent.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-card-content': DapDSCardContent
  }
}
